module.exports = __webpack_public_path__ + "static/media/kiss_laszlo.8c5bf91f.jpg";